/**
 * @author: Radim Buráň <xburan03@stud.fit.vutbr.cz>
 */

import './../AuctionDetail.css';
import {useEffect} from "react";
import { useState } from "react";
import { Fragment } from "react";
import Paper from '@mui/material/Paper';
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
import {Grid} from "@mui/material";
import {getFrom, patchTo, postTo} from "../../../data/api";
import {useAuth} from "../../../data/userContext";
import {isAuthenticated} from "../../../data/roles";
import datetimeDifference from "datetime-difference";


function BidPanel(props) {
    const [auction, setAuction] = useState([]);
    const [bidValue, setBidValue] = useState(0);
    const [userBidValue, setUserBidValue] = useState(0);
    const [isRegistering, setIsRegistering] = useState(true);
    const auth = useAuth();

    useEffect(()=> {
        if (!props.isLoaded) {
            return;
        }
        setAuction(props.auction);

        let sort = props.auction.offerType === "DEMAND" ? "asc" : "desc";
        getFrom('/bids?records=1&orderPrice=' + sort + '&auctionID=' + props.auction.id)
            .then((res)=> {
                if (res.status === 200) {

                    if (res.data[0]) {
                        setBidValue(res.data[0].price)
                    }
                    else {
                        setBidValue(props.auction.startPrice);
                    }

                }
            }).catch((e)=>{
            console.error(e);
        })
    },[props.auction, props.isLoaded])

    function addBid() {
        if (new Date(auction.endAt) <= new Date()) {
            props.setMsgInfo({severity: "error", msg: "Nelze přihazovat po konci aukce!"});
            props.setOpenSnack(true);
            return;
        }


        if (auction.offerType === "DEMAND") {
            if (userBidValue > auction.startPrice) {
                props.setMsgInfo({severity: "error", msg: "Cena musí být nižší než zadaná!"});
                props.setOpenSnack(true);
                return;
            }
            if (userBidValue <= 0) {
                props.setMsgInfo({severity: "error", msg: "Cena tvé nabídky musí být větší než 0 Kč!"});
                props.setOpenSnack(true);
                return;
            }
        }
        else {  //OFFER type
            if (auction.type !== "CLOSED" && userBidValue <= bidValue) {
                props.setMsgInfo({severity: "error", msg: "Příhoz má malou hodnotu!"});
                props.setOpenSnack(true);
                return;
            }
        }

        postTo('/bids', {
            "registeredUserID": props.regUser.id,
            "price": userBidValue
        }).then((res)=> {
            if (res.status === 200) {
                //update prvků
                props.bidAdded(res.data);
                setBidValue(res.data.price);

                props.setMsgInfo({severity: "success", msg: "Úspěšně přihozeno!"});
                props.setOpenSnack(true);

                if (auction.type === "CLOSED") {
                    patchTo('/registeredUsers', {
                        "id": props.regUser.id,
                        "addedBid": true
                    }).then((res)=>{
                        if (res.status === 200) {
                            props.regToAuction(res.data);
                        }
                    }).catch((e)=>{
                    })
                }
            }
        }).catch((e)=>{
            console.error(e);
        })
    }

    function registerToAuction() {
        setIsRegistering(true);
        postTo('/registeredUsers', {
            "userID": auth.user.id,
            "auctionID": auction.id})
            .then((res)=>{
                if (res.status === 200) {
                    props.regToAuction(res.data);
                    props.setMsgInfo({severity: "success", msg: "Zaregistrován do aukce!"});
                    props.setOpenSnack(true);
                }
            }).catch((e)=>{
        }).finally(() => {
            setIsRegistering(false);
        })
    }


    function getStartPriceGrid() {
        return (
            <Fragment>
                <Grid item xs={6} sx={{padding: 1}}>
                    <p>Vyvolávací cena:</p>
                </Grid>

                <Grid item xs={6} sx={{padding: 1}}>
                    <p>{auction.startPrice} Kč</p>
                </Grid>
            </Fragment>
        );
    }

    function getCurrentPriceGrid() {
        return (
          <Fragment>
              <Grid item xs={6} sx={{padding: 1}}>
                  <p>Aktuální cena:</p>
              </Grid>
              <Grid item xs={6} sx={{padding: 1}}>
                  <p>{bidValue} Kč</p>
              </Grid>
          </Fragment>
        );
    }

    const datetimeDiff = datetimeDifference(new Date(), new Date(auction.endAt))

    function getAuctionEndGrid() {
        if (new Date(auction.endAt) <= new Date()) {
            return "";
        }

        return (
            <Fragment>
                <Grid item xs={6} sx={{padding: 1}}>
                    <p>Končí za:</p>
                </Grid>

                <Grid item xs={6} sx={{padding: 1}}>
                    <p>{`${datetimeDiff.months} měsíců
                    ${datetimeDiff.days} dní 
                    ${datetimeDiff.hours} hodin 
                    ${datetimeDiff.minutes} minut `}</p>
                </Grid>
            </Fragment>
        );
    }

    function getCannotBidGrid() {
        return (
            <Fragment>
                <Grid item xs={12} sx={{padding: 1, width: 1}}>
                    <p>Do vlastní aukce nelze přihodit</p>
                </Grid>
            </Fragment>
        )
    }

    function getAlreadyAddedBidGrid() {
        return (
            <Fragment>
                <Grid item xs={12} sx={{padding: 1, width: 1}}>
                    <p>Již jsi přihodil do aukce.</p>
                </Grid>
            </Fragment>
        )
    }

    function getDeniedUserGrid() {
        return (
            <Fragment>
                <Grid item xs={12} sx={{padding: 1, width: 1}}>
                    <p>Přístup k této aukci ti byl zamítnut</p>
                </Grid>
            </Fragment>
        )
    }

    function getWaitingUserGrid() {
        return (
            <Fragment>
                <Grid item xs={12} sx={{padding: 1, width: 1}}>
                    <p>Čekáš na schválení přístupu k aukci</p>
                </Grid>
            </Fragment>
        )
    }

    function getBidButtonGrid() {
        return (
            <Fragment>
                <Grid item xs={4} sx={{padding: 1, width: 1}}>
                    <Button variant="contained" sx={{ height: 55, width: 1}}
                            onClick={() => addBid()}>
                        Přihodit
                    </Button>
                </Grid>
            </Fragment>
        )
    }

    function getRegisterButtonGrid() {
        return (
            <Fragment>
                <Grid item xs={12} sx={{padding: 1, width: 1}}>
                    <Button variant="contained" sx={{ height: 55, width: 1}}
                            isSubmitting={isRegistering}
                            onClick={() => registerToAuction()}>
                        Zaregistrovat se
                    </Button>
                </Grid>
            </Fragment>
        )
    }


    function getButtonGrid() {
        if (!isAuthenticated(auth.user)) {
            return "";
        }

        if (auth.user.id === auction.ownerID || auth.user.id === auction.createByID) {
            return getCannotBidGrid();
        }

        if (props.regUser !== undefined) {
            if (props.regUser.state === "APPROVED") {
                if (auction.type === "CLOSED" && props.regUser.addedBid) {
                    return getAlreadyAddedBidGrid();
                } else {
                    return getBidButtonGrid();
                }
            }
            else if (props.regUser.state === "DENIED") {
                return getDeniedUserGrid();
            }
            else {  //WAITING
                return getWaitingUserGrid();
            }
        }
        else {
            return getRegisterButtonGrid();
        }
    }

    function getMinimumBidValue() {
        if (auction.offerType === "DEMAND") {
            return 1;
        }
        if (auction.type === "OPEN") {
            return bidValue + 1;
        }
        else {
            return auction.startPrice + 1;
        }
    }

    function getMaximumBidValue() {
        if (auction.offerType === "DEMAND") {
            return auction.startPrice;
        }
        else {
            return 2147483647;  //max INT in SQL
        }
    }

    function getBidZoneGrid() {
        if (!isAuthenticated(auth.user)) {
            return "";
        }

        if (auth.user.id === auction.ownerID || auth.user.id === auction.createByID) {
            return "";
        }

        if (props.regUser !== undefined && props.regUser.state === "APPROVED") {
            if (auction.type === "CLOSED" && props.regUser.addedBid) {
                return "";
            }

            return (
                <Grid item xs={8} sx={{padding: 1, width: 1}}>
                    <TextField label="Příhoz" type="number"
                               defaultValue={getMinimumBidValue()}
                               onChange={(e) => setUserBidValue(Number(e.target.value))}
                               InputLabelProps={{
                                   shrink: true,
                               }}
                               InputProps={{
                                   endAdornment: <InputAdornment position="end">Kč</InputAdornment>,
                                   inputProps: {
                                       min: getMinimumBidValue(),
                                       max: getMaximumBidValue()
                                   }
                               }}
                    />
                </Grid>
            );
        }
        else {
            return "";
        }
    }


    function getClosed() {
        return (
            <Fragment>
                <Grid container sx={{width: 1, minWidth: 250}}>
                    <Grid item xs={12} sx={{padding: 1}}>
                        <p>Aukce již byla ukončena</p>
                    </Grid>

                    <Grid item xs={8} sx={{padding: 1}}>
                        <p>Výsledná cena:</p>
                    </Grid>

                    <Grid item xs={4} sx={{padding: 1}}>
                        <p>{bidValue} Kč</p>
                    </Grid>
                </Grid>
            </Fragment>
        );
    }

    function getUnconfirmed() {
        return (
            <Fragment>
                <Grid container sx={{width: 1, minWidth: 250}}>
                    <Grid item xs={12} sx={{padding: 1}}>
                        <p>Aukce čeká na schválení</p>
                    </Grid>
                    {getStartPriceGrid()}
                    {getAuctionEndGrid()}
                </Grid>
            </Fragment>
        );
    }

    function getRefused() {
        return (
            <Fragment>
                <Grid container sx={{width: 1, minWidth: 250}}>
                    <Grid item xs={12} sx={{padding: 1}}>
                        <p>Aukce byla zamítnuta</p>
                    </Grid>
                </Grid>
            </Fragment>
        );
    }

    function getConfirmed() {
        return (
            <Fragment>
                <Grid container sx={{width: 1, minWidth: 250}}>
                    {auction.type === "OPEN" ?
                        getCurrentPriceGrid() :
                        getStartPriceGrid()
                    }

                    {getBidZoneGrid()}

                    {getButtonGrid()}
                    {getAuctionEndGrid()}
                </Grid>
            </Fragment>
        );
    }



    function getBidPanelByStatus() {
        if (auction.status === "CONFIRMED") {
            return getConfirmed();
        }
        else if (auction.status === "UNCONFIRMED") {
            return getUnconfirmed();
        }
        else if (auction.status === "REFUSED") {
            return getRefused();
        }
        else {  //CLOSED
            return getClosed();
        }
    }

    return (
        <Paper elevation={6} sx={{ padding: 2, display: "flex", width: 0.49, minWidth: 400, height: 400, boxSizing: "border-box"}}>
            {getBidPanelByStatus()}
        </Paper>
    );
}


export default BidPanel;